import { assertNever } from '@dadohr/shared/domainTypes/00-assertNever';
import {
  Address,
  EMPTY_ADDRESS,
  isAddressEmpty
} from '@dadohr/shared/domainTypes/address';
import { EMPTY_ARR } from '@dadohr/shared/domainTypes/emptyConstants';
import {
  AdditionalInfo,
  AdditionalInfoType,
  ContentTemplate,
  ContentType,
  CREATE_MEETING_SERVICES,
  IContentCalloutTemplate,
  IExperienceDenormalized,
  isAdditionalInfoDisabled,
  isContentBlock,
  isLayoutTemplateBlock,
  isSubTaskBlock,
  ISubtaskCreateMeetingDenormalized,
  ISubTaskDataFieldChangeDenormalized,
  ISubTaskDocumentReadDenormalized,
  ISubTaskDocuSignEnvelopeSignDenormalized,
  ISubTaskCompleteLmsModuleDenormalized,
  ISubTaskQuestionDenormalized,
  ISubTaskSubmitDenormalized,
  ISubTaskWatchDenormalized,
  ITaskDenormalized,
  LayoutBlock,
  LayoutBlockType,
  QuestionType,
  RequirementType,
  SubTaskDenormalized,
  SubTaskQuestionAnswer,
  SubTaskStatus,
  SubTaskType,
  TaskBlockDenormalized,
  TaskStatus,
  TaskTemplateCompletionCritertiaSubSet
} from '@dadohr/shared/domainTypes/experience';
import { IOrganizationDenormalized } from '@dadohr/shared/domainTypes/org';
import { ProductAnalyticsEvent } from '@dadohr/shared/domainTypes/productAnalytics';
import { IPubSubInstruction } from '@dadohr/shared/domainTypes/pubsub';
import { ISubmitFileMonitor } from '@dadohr/shared/domainTypes/submitFileMonitor';
import { ONE_DAY } from '@dadohr/shared/domainTypes/time';
import { IUserDenormalized } from '@dadohr/shared/domainTypes/user';
import {
  isScaleAnswer,
  isScaleQuestion,
  ScaleAnswerD
} from '@dadohr/shared/domainTypes/questionScale';
import { FS } from '@dadohr/shared/versions';
import { css } from '@emotion/css';
import styled from '@emotion/styled';
import {
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import { validate as isValidEmail } from 'email-validator';
import { ValidationErrors } from 'final-form';
import firebase from 'firebase/app';
import {
  capitalize,
  compact,
  flatten,
  isArray,
  isEqual,
  keyBy,
  mapValues,
  truncate
} from 'lodash';
import {
  AlertCircle,
  Calendar,
  Check,
  CheckCircle2,
  Download,
  ExternalLink,
  Link as LinkIcon,
  MinusCircle,
  Upload,
  X
} from 'lucide-react';
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Img } from 'react-image';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { Link } from 'react-router-dom';
import { AddressForm } from '../../../../components/AddessForm';
import {
  ButtonLoader,
  ButtonWithPromise
} from '../../../../components/ButtonWithPromise';
import { ColoredChipLight } from '../../../../components/ColoredChip';
import {
  CompleteButton,
  CompletedLabel,
  CompleteLabelButton,
  CompleteLink,
  SkippedLabel
} from '../../../../components/CompletionButtons';
import { DocumentTeaserWithPreview } from '../../../../components/DocumentTeaser';
import { Form } from '../../../../components/Form';
import { FormField } from '../../../../components/Form/FormField';
import { FormSubmitButton } from '../../../../components/Form/FormSubmitButton';
import { ImageContainer } from '../../../../components/ImageContainer';
import { InfoBox } from '../../../../components/InfoBox';
import {
  LinearProgressIndeterminateWithLabel,
  LinearProgressWithLabel
} from '../../../../components/LinearProgressWithLabel';
import { MarkdownText, Token } from '../../../../components/MarkdownText';
import { VideoPlayerWithCompletionTracking } from '../../../../components/VideoPlayer';
import { TaskStatusChip } from '../../../../features/Experiences/components/TaskStatusChip';
import { useTranslation, useUnsafeTranslation } from '../../../../i18next';
import {
  FlexContainer,
  FlexContainerVertical,
  FlexItem
} from '../../../../layout/Flex';
import {
  downloadFileFromUrl,
  readFileAsUint8Array
} from '../../../../services/file';
import { storage, store } from '../../../../services/firebase';
import { isMaskedString } from '../../../../services/mask';
import {
  addToTs,
  formatDate,
  now,
  Timestamp,
  toMoment,
  tsIsAfter
} from '../../../../services/time';
import { truncateUrl } from '../../../../services/url';
import { toFullName } from '../../../../services/user';
import { useTheme } from '../../../../themes';
import { useStandaloneAppContext } from '../../../hooks/useStandaloneAppContext';
import {
  AnswerSubTasksResponse,
  removeSubmitFileMonitorDoc,
  trackCompletionIntent,
  trackCompletions,
  useSubmitFileMonitorDoc
} from '../service';
import { useForceRerender } from '../services/forceRerender';
import { SubTaskBackgroundCheckInvite } from './subTasks/SubTaskBackgroundCheckInvite';
import { SubTaskButtonContainer } from './subTasks/common';
import {
  LinearScaleInput,
  RatingInput
} from '../../../../components/ScaleQuestion';
import { SubTaskQuestionField } from './subTasks/SubTaskQuestionField';
import { captureException } from '../../../../sentry';
import { getMaxUploadSizeMb } from './uploadLimits';
import { SubTaskSwagUpChoice } from './subTasks/SubTaskSwagUpChoice';

const TaskHeader = styled('div')<{ dense: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: ${(p) => p.theme.spacing()}px;
  gap: ${(p) => p.theme.spacing()}px;
`;

export type TaskVariant = 'expanded' | 'teaser' | 'normal';

const TaskContainer = styled('div')<{ variant: TaskVariant }>((p) => ({
  marginBottom: p.theme.spacing(p.variant === 'expanded' ? 4 : 2)
}));

const SubtaskLabel = styled('label')<{ hug?: boolean }>((p) => ({
  display: 'block',
  marginTop: p.theme.spacing(p.hug ? 0 : 1),
  fontWeight: p.theme.typography.fontWeightBold
}));

const ONE_MB = 1024 * 1024;

// TODO SUBTASK
// All pending states need to be restyled
const SubTaskSubmit = ({
  s,
  context,
  status,
  mode,
  onSubmitStart
}: {
  s: ISubTaskSubmitDenormalized;
  context: SubTaskContext;
  status: SubTaskStatus;
  mode: 'LIVE' | 'PREVIEW';
  onSubmitStart: () => void;
}) => {
  const { t } = useUnsafeTranslation();
  const monitorId = context.submitFileMonitorId(s.id);
  const [monitor] = useSubmitFileMonitorDoc(monitorId);
  const [
    updloadTask,
    setUploadTask
  ] = useState<firebase.storage.UploadTask | null>(null);
  const [progress, setProgress] = useState<{
    total: number;
    done: number;
  } | null>(null);

  // Destination-aware upload cap (Sondermind, bead new-main): 20MB for streamed
  // destinations (Drive/OneDrive/SharePoint), 10MB for EMAIL/unknown. See ./uploadLimits.
  const MAX_FILE_SIZE_MB = getMaxUploadSizeMb(s.data?.to?.type);
  const [error, setError] = useState<
    'FILE_TOO_LARGE' | 'HEIC_NOT_ALLOWED' | 'UPLOAD_FAILED' | null
  >(null);

  const abort = useCallback(() => {
    if (updloadTask) {
      updloadTask.cancel();
    }
    setError(null);
    setProgress(null);
    removeSubmitFileMonitorDoc(monitorId);
  }, [context, updloadTask]);

  useEffect(() => {
    if (!updloadTask) {
      setProgress(null);
      return;
    }

    const unlisten = updloadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      (s) => {
        setProgress({
          total: s.totalBytes,
          done: s.bytesTransferred
        });
      },
      (err) => {
        // A storage upload failed. Previously this only console.log'd (the
        // "// TODO add a snack"): the participant was left with a stuck
        // progress bar and no feedback, and the submitFileMonitor doc stranded
        // at status 'UPLOAD' — the invisible-failure mode behind reports of
        // "uploads failing with no evidence". Surface it: clear the progress
        // UI so the helper error can render, and drop the dead monitor doc so
        // a retry starts clean (mirrors abort()'s cleanup). A user-initiated
        // cancel is not an error — abort() already cleaned up — so stay quiet.
        const code = (err as { code?: string }).code;
        setProgress(null);
        if (code === 'storage/canceled') {
          return;
        }
        console.warn('FILE_UPLOAD_FAILED', code, err);
        // A genuine upload failure (not a client validation) — report the real
        // Firebase storage error so these stop being invisible console.logs.
        captureException(err, {
          level: 'error',
          tags: { reason: 'UPLOAD_FAILED', storageErrorCode: code ?? 'unknown' },
          extra: { subTaskId: s.id, monitorId }
        });
        setError('UPLOAD_FAILED');
        removeSubmitFileMonitorDoc(monitorId);
      },
      () => {
        // TODO add a snack
        console.log('Upload successful');
      }
    );
    return () => unlisten();
  }, [updloadTask]);

  const abortAction = (
    <Tooltip title={`${t('Cancel')}`}>
      <IconButton onClick={abort}>
        <X size={20} />
      </IconButton>
    </Tooltip>
  );

  if (monitor && monitor.data.status === 'DELIVERY') {
    return (
      <LinearProgressIndeterminateWithLabel
        label={`${t('standaloneApp.Delivering')}...`}
        action={abortAction}
      />
    );
  }

  if (progress && monitor?.data.status !== 'SUCCESS') {
    return (
      <LinearProgressWithLabel
        value={(progress.done / progress.total) * 100}
        action={abortAction}
      />
    );
  }

  return (
    <SubTaskButtonContainer>
      <input
        id={`file-input-${s.id}`}
        type="file"
        hidden
        onChange={async (ev) => {
          if (mode === 'PREVIEW') {
            return;
          }
          console.log('NEXT FILE');
          const files = ev.target.files;
          if (!files || files.length === 0) {
            console.log('No file');
            return;
          }
          const fileCount = files.length || 0;
          if (fileCount > 1) {
            console.log('Only one file supported');
            return;
          }
          const file = files[0];

          if (file.type === 'image/heif' || file.name.match(/\.heic$/i)) {
            // Observable in Sentry like the size reject — also a pre-network,
            // otherwise-traceless client rejection.
            const heicInfo = context.constructNextFileSubmitMonitor(file, s.id);
            captureException(new Error('FILE_UPLOAD_HEIC_NOT_ALLOWED'), {
              level: 'warning',
              tags: { reason: 'HEIC_NOT_ALLOWED' },
              extra: {
                experienceId: heicInfo.experienceId,
                taskId: heicInfo.taskId,
                subTaskId: s.id,
                fileName: file.name,
                fileType: file.type,
                fileSizeBytes: file.size
              }
            });
            setError('HEIC_NOT_ALLOWED');
            return;
          }

          if (file.size > MAX_FILE_SIZE_MB * ONE_MB) {
            // Surface the client-side size rejection to Sentry. This reject
            // happens BEFORE any network call, so it otherwise leaves no
            // server / Firestore / analytics trace — which is exactly why
            // large-file upload failures were unprovable. Warning level; the
            // context pinpoints the submission and the offending file size.
            const submitInfo = context.constructNextFileSubmitMonitor(file, s.id);
            captureException(new Error('FILE_UPLOAD_TOO_LARGE'), {
              level: 'warning',
              tags: { reason: 'FILE_TOO_LARGE' },
              extra: {
                experienceId: submitInfo.experienceId,
                taskId: submitInfo.taskId,
                subTaskId: s.id,
                fileName: file.name,
                fileType: file.type,
                fileSizeBytes: file.size,
                fileSizeMB: Math.round((file.size / ONE_MB) * 100) / 100,
                maxFileSizeMB: MAX_FILE_SIZE_MB
              }
            });
            setError('FILE_TOO_LARGE');
            return;
          } else {
            error && setError(null);
          }

          const nextMonitor: ISubmitFileMonitor = context.constructNextFileSubmitMonitor(
            file,
            s.id
          );
          await store()
            .collection(FS.submitFileMonitor)
            .doc(monitorId)
            .set(nextMonitor);
          const asBuffer = await readFileAsUint8Array(file);
          const onComplete: IPubSubInstruction = {
            topic: 'exp-subTask-fileUploadComplete',
            payload: {
              monitorId
            }
          };
          setUploadTask(
            storage()
              .ref(nextMonitor.storageRef)
              .put(asBuffer, {
                contentType: file.type,
                customMetadata: {
                  fileName: file.name,
                  onComplete: JSON.stringify(onComplete),
                  experienceId: nextMonitor.experienceId,
                  taskId: nextMonitor.taskId,
                  subTaskId: s.id
                }
              })
          );
          onSubmitStart();
        }}
      />
      <div>
        <CompleteLabelButton
          startIcon={<Upload size={16} />}
          htmlFor={`file-input-${s.id}`}
          status={status}
          keepEnabledWhenNotOpen
        >
          {monitor && monitor.data.originalFileName
            ? truncate(monitor.data.originalFileName, { length: 60 })
            : `${capitalize(t('subTask.submit.verb'))} ${
                s.data.label || t('file')
              }`}
        </CompleteLabelButton>
        {error && (
          <FormHelperText error>
            {error === 'FILE_TOO_LARGE' &&
              t('Please choose a file smaller than {{ maxFileSize }}', {
                maxFileSize: `${MAX_FILE_SIZE_MB}MB`
              })}
            {error === 'HEIC_NOT_ALLOWED' &&
              t(
                'HEIC images are not supported. Please upload your image in PNG or JPG format.'
              )}
            {error === 'UPLOAD_FAILED' &&
              t('Your file could not be uploaded. Please try again.')}
          </FormHelperText>
        )}
      </div>
    </SubTaskButtonContainer>
  );
};

const CreateMeetingSubtaskContainer = styled('div')((p) => ({
  border: p.theme.custom.border.standard,
  borderRadius: p.theme.custom.border.radius()
}));

const CreateMeetingSubtaskInnerContainer = styled(FlexContainer)((p) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: p.theme.spacing(2),
  gap: p.theme.spacing(2)
}));

const CreateMeetingSubTaskRow = styled(FlexContainer)<{
  additionalTopMargin?: boolean;
}>((p) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: p.theme.spacing(1)
}));

const CreateMeetingSubTaskCompleteContainer = styled('div')<{
  color: 'green' | 'gray';
}>((p) => ({
  padding: p.theme.spacing(2),
  color: p.theme.custom.colors[p.color].w700,
  background: p.theme.custom.colors[p.color].w200
}));

const CreateMeetingSubTaskCompleteContainerHeadline = styled('div')((p) => ({
  fontWeight: p.theme.typography.fontWeightBold,

  display: 'flex',
  alignItems: 'center',
  gap: p.theme.spacing(0.5),
  marginBottom: p.theme.spacing(0.5)
}));

const SubtaskCreateCalendarEvent = ({
  context,
  subtask,
  onComplete
}: {
  context: SubTaskContext;
  subtask: ISubtaskCreateMeetingDenormalized;
  onComplete: () => void;
}) => {
  const { t } = useUnsafeTranslation();
  const { title, description, resolvedInvitees } = subtask.data;
  return (
    <CreateMeetingSubtaskContainer>
      {subtask.status === SubTaskStatus.DONE && (
        <CreateMeetingSubTaskCompleteContainer color="green">
          <CreateMeetingSubTaskCompleteContainerHeadline>
            <CheckCircle2 size={14} strokeWidth={3} />
            <div>
              {subtask.lastCompletedAt
                ? t('Used on {{ date }}', {
                    date: toMoment(subtask.lastCompletedAt).format(
                      'MMM DD, hh:mma'
                    )
                  })
                : t('Completed')}
            </div>
          </CreateMeetingSubTaskCompleteContainerHeadline>

          <div>
            {t('You can still create a new event from the suggested content.')}
          </div>
        </CreateMeetingSubTaskCompleteContainer>
      )}
      {subtask.status === SubTaskStatus.SKIPPED && (
        <CreateMeetingSubTaskCompleteContainer color="gray">
          <CreateMeetingSubTaskCompleteContainerHeadline>
            <MinusCircle size={14} strokeWidth={3} />
            <div>{t('Skipped')}</div>
          </CreateMeetingSubTaskCompleteContainerHeadline>
          <div>
            {t('You can still create a new event from the suggested content.')}
          </div>
        </CreateMeetingSubTaskCompleteContainer>
      )}
      <CreateMeetingSubtaskInnerContainer>
        <CreateMeetingSubTaskRow>
          <SubtaskLabel htmlFor={subtask.id} hug>
            <Typography variant="h6" component="h6">
              {t('Who should be invited')}
            </Typography>
          </SubtaskLabel>
          <FlexContainer wrap={'wrap'}>
            {resolvedInvitees.map((p) => (
              <Token color="gray">{p.email}</Token>
            ))}
          </FlexContainer>
        </CreateMeetingSubTaskRow>
        <CreateMeetingSubTaskRow>
          <SubtaskLabel htmlFor={subtask.id} hug>
            <Typography variant="h6" component="h6">
              {t('Event Title')}
            </Typography>
          </SubtaskLabel>
          <Typography component="p" variant="body2">
            {title}
          </Typography>
        </CreateMeetingSubTaskRow>
        <CreateMeetingSubTaskRow>
          <SubtaskLabel htmlFor={subtask.id} hug>
            <Typography variant="h6" component="h6">
              {t('Description')}
            </Typography>
          </SubtaskLabel>
          <Typography component="p" variant="body2">
            {description}
          </Typography>
        </CreateMeetingSubTaskRow>
        <CreateMeetingSubTaskRow>
          <SubtaskLabel htmlFor={subtask.id} hug>
            <Typography variant="h6" component="h6">
              {t('Suggested Date')}
            </Typography>
          </SubtaskLabel>
          <Typography component="p" variant="body2">
            {moment(subtask.data.eventDate)
              .tz(context.tz)
              .format('MMMM Do YYYY HH:mm z')}
          </Typography>
        </CreateMeetingSubTaskRow>
        <CreateMeetingSubTaskRow>
          <FlexContainer>
            {subtask.data.calendarLinks.map((l) => (
              <Button
                key={l.url}
                variant="outlined"
                color="primary"
                target="_blank"
                rel="noopener"
                onClick={() => {
                  return onComplete();
                }}
                href={context.getSubTaskVisitUrl(subtask.id, l.url)}
                endIcon={<ExternalLink size={16} />}
              >
                {t('Open in {{ service }}', {
                  service: CREATE_MEETING_SERVICES[l.type].name
                })}
              </Button>
            ))}
          </FlexContainer>
          <Typography component="p" variant="caption">
            {t('You can make changes before creating the meeting.')}
          </Typography>
        </CreateMeetingSubTaskRow>
      </CreateMeetingSubtaskInnerContainer>
    </CreateMeetingSubtaskContainer>
  );
};

const QuestionTextInputRow = styled('div')`
  display: grid;
  align-items: flex-end;
  grid-template-columns: 1fr;
  grid-column-gap: ${(p) => p.theme.spacing(1)}px;
  grid-row-gap: ${(p) => p.theme.spacing(1)}px;
  padding-bottom: ${(p) => p.theme.spacing(1.5)}px;

  @media (min-width: 600px) {
    grid-template-columns: 1fr max-content;
  }
`;

const QuestionButtonContainer = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center',
  alignSelf: 'center',
  gap: p.theme.spacing(1),
  width: '100%'
}));

export const QuestionLabel = styled('label')((p) => ({
  display: 'block',
  fontWeight: p.theme.typography.fontWeightMedium,
  marginBottom: p.theme.spacing()
}));

const QuestionRadioContainer = styled('div')((p) => ({
  marginBottom: p.theme.spacing(),
  legend: {
    marginBottom: p.theme.spacing()
  }
}));

const hasErrors = (errors: ValidationErrors) => {
  if (errors === undefined) {
    return false;
  } else if (errors instanceof Array) {
    return errors.length > 0;
  } else {
    return Object.values(errors).length > 0;
  }
};

const SubTaskQuestionSingle = React.memo(
  ({
    context,
    s,
    highlight,
    onSubmitDone,
    status,
    mode,
    dateFormat = 'MM/DD/YYYY'
  }: {
    context: SubTaskContext;
    s: ISubTaskQuestionDenormalized;
    highlight: boolean;
    onSubmitDone: () => void;
    status: SubTaskStatus;
    mode: 'LIVE' | 'PREVIEW';
    dateFormat?: string;
  }) => {
    // console.log('re-render question');
    const { t } = useTranslation();
    const { t: ut } = useUnsafeTranslation();
    const disabled = status === SubTaskStatus.SKIPPED;
    const id = `sub-task-preview-question-${s.id}`;

    const { question } = s.data;

    if (question.type === 'text') {
      const initialValues = {
        answer:
          (s.data.answer?.d.type === 'text' && s.data.answer?.d.value) || ''
      };
      return (
        <>
          <Form<{ answer: string }>
            initialValues={initialValues}
            onSubmit={async ({ answer }) => {
              if (mode === 'PREVIEW') {
                return;
              }
              if (question.sensitive && isMaskedString(answer)) {
                return;
              }

              await context
                .answerSubTask(s.id, {
                  type: QuestionType.TEXT,
                  value: answer
                })
                .then(({ completions }) =>
                  trackCompletions(completions, context.trackEvent)
                );

              return onSubmitDone();
            }}
          >
            {({ submitting, values, errors }) => {
              return (
                <>
                  <FlexContainer
                    direction={question.rows === 1 ? 'row' : 'column'}
                    justifyContent="flex-start"
                    alignItems={question.rows === 1 ? 'flex-start' : 'stretch'}
                  >
                    <FlexItem flex={question.rows === 1 ? 1 : 'auto'}>
                      <SubTaskQuestionField
                        s={s}
                        qId={id}
                        disabled={disabled}
                        highlight={highlight}
                        mode="single"
                        dateFormat={dateFormat}
                      />
                    </FlexItem>

                    <div
                      style={{
                        paddingTop: question.rows === 1 ? 'calc(1.5em + 8px)' : '2px'
                      }}
                    >
                      <FlexContainer
                        justifyContent={
                          question.rows === 1 ? 'flex-end' : 'flex-start'
                        }
                        alignItems={'center'}
                      >
                        <FormSubmitButton
                          variant={'contained'}
                          color={'primary'}
                          disabled={
                            hasErrors(errors) ||
                            !values.answer ||
                            values.answer === initialValues.answer ||
                            (question.sensitive &&
                              isMaskedString(values.answer)) ||
                            disabled
                          }
                          submitting={submitting}
                          submitComponent={
                            <>
                              <ButtonLoader /> {'Submit'}
                            </>
                          }
                        >
                          {'Submit'}
                        </FormSubmitButton>
                        {status === SubTaskStatus.DONE && (
                          <FlexItem flex="none">
                            <CompletedLabel />
                          </FlexItem>
                        )}
                        {status === SubTaskStatus.SKIPPED && (
                          <FlexItem flex="none">
                            <SkippedLabel />
                          </FlexItem>
                        )}
                      </FlexContainer>
                    </div>
                  </FlexContainer>
                </>
              );
            }}
          </Form>
        </>
      );
    }

    if (question.type === 'address') {
      const initialValues = {
        answer:
          (s.data.answer?.d.type === 'address' && s.data.answer?.d.value) ||
          EMPTY_ADDRESS()
      };

      return (
        <>
          <Form<{ answer: Address }>
            initialValues={initialValues}
            onSubmit={async ({ answer }) => {
              if (mode === 'PREVIEW') {
                return;
              }
              if (
                question.sensitive &&
                Object.values(answer).some(isMaskedString)
              ) {
                return;
              }

              return context
                .answerSubTask(s.id, {
                  type: QuestionType.ADDRESS,
                  value: answer
                })
                .then(onSubmitDone);
            }}
          >
            {({ submitting, values }) => {
              return (
                <>
                  {question.label && (
                    <QuestionLabel htmlFor={id}>{question.label}</QuestionLabel>
                  )}
                  <FormField<Address> name="answer">
                    {({ input }) => (
                      <AddressForm
                        value={input.value}
                        onChange={input.onChange}
                        autoFocus={highlight}
                        disabled={disabled}
                        excludedFields={question.excludedFields}
                      />
                    )}
                  </FormField>
                  <QuestionButtonContainer>
                    <FormSubmitButton
                      variant={'contained'}
                      color={'primary'}
                      disabled={
                        !values.answer ||
                        values.answer === initialValues.answer ||
                        (question.sensitive &&
                          Object.values(values.answer).every(isMaskedString)) ||
                        disabled
                      }
                      submitting={submitting}
                      submitComponent={
                        <>
                          <ButtonLoader /> {'Submit'}
                        </>
                      }
                    >
                      {'Submit'}
                    </FormSubmitButton>
                    {status === SubTaskStatus.DONE && <CompletedLabel />}
                    {status === SubTaskStatus.SKIPPED && <SkippedLabel />}
                  </QuestionButtonContainer>
                </>
              );
            }}
          </Form>
        </>
      );
    }

    if (question.type === 'multiSelect') {
      const initialValues = {
        answers:
          s.data.answer?.d.type === 'multiSelect'
            ? s.data.answer.d.value?.map((v) => v.id) || []
            : []
      };
      return (
        <>
          <Form<{ answers: string[] }>
            initialValues={initialValues}
            onSubmit={async ({ answers }) => {
              if (mode === 'PREVIEW' || !answers) {
                return;
              }

              return context
                .answerSubTask(s.id, {
                  type: QuestionType.MULTI_SELECT,
                  value: compact(
                    answers.map((id) =>
                      question.options.find((o) => o.id === id)
                    )
                  )
                })
                .then(onSubmitDone);
            }}
          >
            {({ submitting, values }) => {
              const submitButton = (
                <QuestionButtonContainer>
                  <FormSubmitButton
                    variant={'contained'}
                    color={'primary'}
                    disabled={
                      !values.answers ||
                      isEqual(values.answers, initialValues.answers) ||
                      disabled
                    }
                    submitting={submitting}
                    submitComponent={
                      <>
                        <ButtonLoader /> {t('Submit')}
                      </>
                    }
                  >
                    {t('Submit')}
                  </FormSubmitButton>
                  {status === SubTaskStatus.DONE && <CompletedLabel />}
                  {status === SubTaskStatus.SKIPPED && <SkippedLabel />}
                </QuestionButtonContainer>
              );

              return (
                <>
                  <QuestionRadioContainer>
                    <FormControl component="fieldset">
                      <QuestionLabel htmlFor={id}>
                        {question.label}
                      </QuestionLabel>

                      <FormGroup>
                        {question.options.map((o) => {
                          return (
                            <FormField
                              name="answers"
                              type="checkbox"
                              key={o.id}
                              value={o.id}
                            >
                              {({ input }) => (
                                <FormControlLabel
                                  key={o.id}
                                  value={o.id}
                                  control={
                                    <Checkbox color="primary" {...input} />
                                  }
                                  label={o.label}
                                />
                              )}
                            </FormField>
                          );
                        })}
                      </FormGroup>
                    </FormControl>
                  </QuestionRadioContainer>
                  <div>{submitButton}</div>
                </>
              );
            }}
          </Form>
        </>
      );
    }

    if (question.type === 'select') {
      const initialValues = {
        answer:
          s.data.answer?.d.type === 'select' ? s.data.answer.d.value : null
      };
      return (
        <>
          <Form<{ answer: { id: string; label: string } | null }>
            initialValues={initialValues}
            onSubmit={async ({ answer }) => {
              if (mode === 'PREVIEW' || !answer) {
                return;
              }
              return context
                .answerSubTask(s.id, {
                  type: QuestionType.SELECT,
                  value: answer
                })
                .then(onSubmitDone);
            }}
          >
            {({ submitting, values }) => {
              const submitButton = (
                <QuestionButtonContainer>
                  <FormSubmitButton
                    variant={'contained'}
                    color={'primary'}
                    disabled={
                      !values.answer ||
                      values.answer.id === initialValues.answer?.id ||
                      disabled
                    }
                    submitting={submitting}
                    submitComponent={
                      <>
                        <ButtonLoader /> {t('Submit')}
                      </>
                    }
                  >
                    {t('Submit')}
                  </FormSubmitButton>
                  {status === SubTaskStatus.DONE && <CompletedLabel />}
                  {status === SubTaskStatus.SKIPPED && <SkippedLabel />}
                </QuestionButtonContainer>
              );

              return question.options.length < 5 ? (
                <>
                  <QuestionRadioContainer>
                    <FormControl component="fieldset">
                      <QuestionLabel htmlFor={id}>
                        {question.label}
                      </QuestionLabel>

                      <FormField<{ id: string; label: string }> name="answer">
                        {({ input }) => (
                          <RadioGroup
                            name={id}
                            value={input.value?.id || null}
                            onChange={(ev) => {
                              const opt = question.options.find(
                                (o) => o.id === ev.target.value
                              );
                              if (opt) {
                                input.onChange(opt);
                              }
                            }}
                          >
                            {question.options.map((o) => (
                              <FormControlLabel
                                classes={{
                                  root: css({
                                    '&&': { alignItems: 'flex-start' }
                                  })
                                }}
                                key={o.id}
                                value={o.id}
                                control={<Radio color="primary" />}
                                label={o.label}
                              />
                            ))}
                          </RadioGroup>
                        )}
                      </FormField>
                    </FormControl>
                  </QuestionRadioContainer>
                  <div>{submitButton}</div>
                </>
              ) : (
                <>
                  <QuestionLabel htmlFor={id}>{question.label}</QuestionLabel>
                  <QuestionTextInputRow>
                    <FormField<{ id: string; label: string }> name="answer">
                      {({ input }) => (
                        <Select
                          fullWidth
                          id={id}
                          variant="outlined"
                          value={input.value?.id || ''}
                          onChange={(ev) => {
                            const opt = question.options.find(
                              (o) => o.id === ev.target.value
                            );
                            if (opt) {
                              input.onChange(opt);
                            }
                          }}
                          autoFocus={highlight}
                          disabled={disabled}
                        >
                          {question.options.map((o) => (
                            <MenuItem key={o.id} value={o.id}>
                              {o.label}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </FormField>
                    {submitButton}
                  </QuestionTextInputRow>
                </>
              );
            }}
          </Form>
        </>
      );
    }

    if (question.type === QuestionType.SUPPORTING_ACTOR) {
      const initialValues = {
        answer:
          (s.data.answer?.d.type === QuestionType.SUPPORTING_ACTOR &&
            s.data.answer?.d.value) ||
          ''
      };
      return (
        <>
          <Form<{ answer: string }>
            initialValues={initialValues}
            onSubmit={async ({ answer }) => {
              if (mode === 'PREVIEW') {
                return;
              }

              return context
                .answerSubTask(s.id, {
                  type: QuestionType.SUPPORTING_ACTOR,
                  value: answer
                })
                .then(onSubmitDone);
            }}
          >
            {({ submitting, values, errors }) => {
              return (
                <>
                  <QuestionLabel htmlFor={id}>{question.label}</QuestionLabel>
                  <FlexContainer
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <FlexItem flex={1}>
                      <FormField<string>
                        validate={(input) => {
                          if (
                            s.requirementType !== RequirementType.MANDATORY &&
                            (!input || input.trim() === '')
                          ) {
                            return undefined;
                          }
                          return input && isValidEmail(input)
                            ? undefined
                            : ut(
                                "Please enter this person's work email address"
                              );
                        }}
                        name="answer"
                      >
                        {({ input, meta }) => (
                          <TextField
                            id={id}
                            fullWidth
                            variant="outlined"
                            multiline={false}
                            rows={1}
                            value={input.value}
                            placeholder={ut('Enter their work email address')}
                            helperText={
                              meta.dirty && meta.error ? meta.error : ''
                            }
                            onChange={input.onChange}
                            autoFocus={highlight}
                            disabled={disabled}
                            error={meta.dirty && meta.error}
                            InputProps={{
                              readOnly: disabled
                            }}
                            type={'text'}
                          />
                        )}
                      </FormField>
                    </FlexItem>

                    <FlexContainer justifyContent="flex-end">
                      <FormSubmitButton
                        variant={'contained'}
                        color={'primary'}
                        disabled={
                          hasErrors(errors) ||
                          !values.answer ||
                          values.answer === initialValues.answer ||
                          disabled
                        }
                        submitting={submitting}
                        submitComponent={
                          <>
                            <ButtonLoader /> {'Submit'}
                          </>
                        }
                      >
                        {'Submit'}
                      </FormSubmitButton>
                      {status === SubTaskStatus.DONE && (
                        <FlexItem flex="none">
                          <CompletedLabel />
                        </FlexItem>
                      )}
                      {status === SubTaskStatus.SKIPPED && (
                        <FlexItem flex="none">
                          <SkippedLabel />
                        </FlexItem>
                      )}
                    </FlexContainer>
                  </FlexContainer>
                </>
              );
            }}
          </Form>
        </>
      );
    }
    if (isScaleQuestion(question)) {
      const initialAnswer =
        s.data.answer?.d && isScaleAnswer(s.data.answer.d)
          ? s.data.answer.d.value
          : null;
      const initialValues = { answer: initialAnswer };
      return (
        <>
          <Form<{ answer: number | null }>
            initialValues={initialValues}
            onSubmit={async ({ answer }) => {
              if (mode === 'PREVIEW' || answer === null) {
                return;
              }
              const d: ScaleAnswerD =
                question.type === QuestionType.RATING
                  ? { type: QuestionType.RATING, value: answer }
                  : { type: QuestionType.LINEAR_SCALE, value: answer };
              return context.answerSubTask(s.id, d).then(onSubmitDone);
            }}
          >
            {({ submitting, values }) => (
              <>
                <QuestionRadioContainer>
                  <FormControl component="fieldset">
                    <QuestionLabel htmlFor={id}>{question.label}</QuestionLabel>
                    <FormField<number | null> name="answer">
                      {({ input }) => (
                        question.type === QuestionType.RATING ? (
                          <RatingInput
                            question={question}
                            value={input.value ?? null}
                            onChange={(next) => input.onChange(next)}
                            name={id}
                            id={id}
                            disabled={disabled}
                          />
                        ) : (
                          <LinearScaleInput
                            question={question}
                            value={input.value ?? null}
                            onChange={(next) => input.onChange(next)}
                            name={id}
                            id={id}
                            disabled={disabled}
                          />
                        )
                      )}
                    </FormField>
                  </FormControl>
                </QuestionRadioContainer>
                <QuestionButtonContainer>
                  <FormSubmitButton
                    variant={'contained'}
                    color={'primary'}
                    disabled={
                      values.answer === null ||
                      values.answer === initialValues.answer ||
                      disabled
                    }
                    submitting={submitting}
                    submitComponent={
                      <>
                        <ButtonLoader /> {t('Submit')}
                      </>
                    }
                  >
                    {t('Submit')}
                  </FormSubmitButton>
                  {status === SubTaskStatus.DONE && <CompletedLabel />}
                  {status === SubTaskStatus.SKIPPED && <SkippedLabel />}
                </QuestionButtonContainer>
              </>
            )}
          </Form>
        </>
      );
    }
    return null;
  },
  (prev, next) => {
    // Why do we want to do this?

    // When we submit an answer, we trigger a force re-render, which re-fetches data from the backend.
    // The first data that comes in is still the old data. We are not interested in it. We wait
    // until editedAt has really changed, that's when we know that the data is fresh.

    // console.log(
    //   'Why does it re-render? Even if this claims to be equal?',
    //   prev.experienceId === next.experienceId &&
    //     prev.taskId === next.taskId &&
    //     prev.highlight === next.highlight &&
    //     prev.s.id === next.s.id &&
    //     prev.s.data.answer?.editedAt.toMillis() ===
    //       next.s.data.answer?.editedAt.toMillis(),
    //   prev.s.data.answer?.editedAt.toMillis(),
    //   next.s.data.answer?.editedAt.toMillis()
    // );
    return (
      prev.context.submitFileMonitorId === next.context.submitFileMonitorId &&
      prev.context.tz === next.context.tz &&
      prev.context.userId === next.context.userId &&
      prev.highlight === next.highlight &&
      prev.s.id === next.s.id &&
      prev.status === next.status &&
      prev.s.data.answer?.editedAt.toMillis() ===
        next.s.data.answer?.editedAt.toMillis()
    );
  }
);

const DateFieldChangeSubtaskContainer = styled('div')((p) => ({
  borderColor: p.theme.palette.grey[200],
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: p.theme.custom.border.radius(),
  display: 'flex',
  flexDirection: 'column',
  padding: p.theme.spacing(3),
  gap: p.theme.spacing(2)
}));

const DateFieldChangeSubtaskNote = styled('div')((p) => ({
  paddingTop: p.theme.spacing(1),
  color: p.theme.palette.grey[400],
  fontSize: p.theme.custom.fontSize.s
}));

const SubTaskDateFieldChange = ({
  s,
  status
}: {
  s: ISubTaskDataFieldChangeDenormalized;
  status: SubTaskStatus;
}) => {
  const { t } = useUnsafeTranslation();

  return (
    <DateFieldChangeSubtaskContainer>
      <div>
        <ColoredChipLight
          variant="squared"
          color={status === SubTaskStatus.OPEN ? 'yellow' : 'green'}
        >
          {status === SubTaskStatus.OPEN ? 'Not Completed' : 'Completed'}
        </ColoredChipLight>
      </div>
      <MarkdownText t={s.data.instructions} />

      <DateFieldChangeSubtaskNote>
        {t('Note this can take serveral days to appear marked as done in Dado')}
      </DateFieldChangeSubtaskNote>
    </DateFieldChangeSubtaskContainer>
  );
};

const SubTaskDocuSignEnvelopeSign = ({
  s,
  status
}: {
  s: ISubTaskDocuSignEnvelopeSignDenormalized;
  status: SubTaskStatus;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <FlexContainerVertical fullWidth spacing={1}>
      {s.data.description && <MarkdownText t={s.data.description} />}
      <FlexContainer>
        <strong>{`${t('Signature status')}:`}</strong>
        <ColoredChipLight
          variant="rounded"
          size="small"
          color={
            status === SubTaskStatus.DONE
              ? 'green'
              : status === SubTaskStatus.SKIPPED
              ? 'gray'
              : 'blue'
          }
        >
          {status === SubTaskStatus.DONE
            ? t('Completed')
            : status === SubTaskStatus.SKIPPED
            ? t('Skipped')
            : t('To Do')}
        </ColoredChipLight>
      </FlexContainer>
      <Typography variant="caption">
        {t(
          'This status will automatically update once you have signed on the Docusign platform.'
        )}
      </Typography>
    </FlexContainerVertical>
  );
};

// Participant view for a "Complete LMS module" subtask. Informational: the
// participant completes the course in Docebo; the subtask auto-completes via
// webhook/poll. TODO: final copy/design.
const SubTaskCompleteLmsModule = ({
  s,
  status
}: {
  s: ISubTaskCompleteLmsModuleDenormalized;
  status: SubTaskStatus;
}) => {
  const { t } = useUnsafeTranslation();
  const supportEmail = s.data.supportContact?.email;
  return (
    <FlexContainerVertical fullWidth spacing={1}>
      {s.data.description && <MarkdownText t={s.data.description} />}
      <FlexContainer>
        <strong>{`${t('Course')}:`}</strong>
        <span>{s.data.unit.name}</span>
      </FlexContainer>
      {s.data.subdomain && (
        <Button
          href={`https://${s.data.subdomain}.docebosaas.com/learn/mycourses`}
          target="_blank"
          rel="noopener noreferrer"
          variant="text"
          color="primary"
          startIcon={
            <img
              src="/images/docebo-tiny-logo.svg"
              alt=""
              width={16}
              height={16}
              style={{ objectFit: 'contain' }}
            />
          }
          style={{
            alignSelf: 'flex-start',
            textTransform: 'none',
            paddingLeft: 0
          }}
        >
          {t('Open your Docebo homepage')}
        </Button>
      )}
      {supportEmail && (
        <Typography variant="caption" color="textSecondary">
          {t('Something not working? Contact')}{' '}
          <a href={`mailto:${supportEmail}`} style={{ color: 'inherit' }}>
            {supportEmail}
          </a>
        </Typography>
      )}
      <FlexContainer>
        <strong>{`${t('Status')}:`}</strong>
        <ColoredChipLight
          variant="rounded"
          size="small"
          color={
            status === SubTaskStatus.DONE
              ? 'green'
              : status === SubTaskStatus.SKIPPED
              ? 'gray'
              : 'blue'
          }
        >
          {status === SubTaskStatus.DONE
            ? t('Completed')
            : status === SubTaskStatus.SKIPPED
            ? t('Skipped')
            : t('To Do')}
        </ColoredChipLight>
      </FlexContainer>
      <Typography variant="caption">
        {t(
          'This status will automatically update once you complete the course in your LMS.'
        )}
      </Typography>
    </FlexContainerVertical>
  );
};

const SubTaskQuestionMulti = React.memo(
  ({
    context,
    highlightedBlockId,
    ss,
    dateFormat = 'MM/DD/YYYY'
  }: {
    context: SubTaskContext;
    highlightedBlockId: string | undefined;
    ss: ISubTaskQuestionDenormalized[];
    dateFormat?: string;
  }) => {
    const { t } = useUnsafeTranslation();
    const { mode } = useStandaloneAppContext();
    const initialValues = mapValues(
      keyBy(ss, (s) => s.id),
      (s) => {
        const d = s.data.answer?.d;
        if (!d) {
          return null;
        }
        if (d.type === 'multiSelect') {
          // this is a bit weird unfortunately. final form checkboxes cannot
          // deal with complex objects. We could wrap the whole checkbox group
          // in theory, but for simplicity's sake we just identify multiSelect
          // answers by isArray - everything else is objects.
          return d.value?.map((v) => v.id) || [];
        }
        return d;
      }
    );
    const { forceRerender } = useForceRerender();
    const onSubmitDone = (res?: AnswerSubTasksResponse) => {
      // TODO res is only passed in experiences at the moment - it's not passed from moments
      if (res?.status === 'SKIPPED') {
        return;
      }
      res?.answers.forEach((s) =>
        context.trackSubTaskCompletion(s.subTaskId, SubTaskType.QUESTION)
      );
      // force to DONE state?
      console.log('Is onSubmit done called?');
      forceRerender();
    };

    return (
      <>
        <Form<typeof initialValues>
          initialValues={initialValues}
          onSubmit={async (values) => {
            if (mode === 'PREVIEW') {
              return;
            }
            // we make sure earlier that no null values are in here
            const answers = compact(
              ss.map<{
                subTaskId: string;
                d: SubTaskQuestionAnswer['d'];
              } | null>((s) => {
                const d = values[s.id];
                if (!d) {
                  return null;
                }
                if (isArray(d)) {
                  if (s.data.question.type === 'multiSelect') {
                    return {
                      subTaskId: s.id,
                      d: {
                        type: QuestionType.MULTI_SELECT,
                        value: s.data.question.options.filter((o) =>
                          d.includes(o.id)
                        )
                      }
                    };
                  }
                  // should never happen
                  return null;
                }
                if (
                  s.data.question.type === 'text' &&
                  s.data.question.sensitive
                ) {
                  if (d.type === 'text' && isMaskedString(d.value)) {
                    return null;
                  }
                }
                if (
                  s.data.question.type === 'address' &&
                  s.data.question.sensitive
                ) {
                  if (
                    d.type === 'address' &&
                    Object.values(d.value).some(isMaskedString)
                  ) {
                    return null;
                  }
                }

                return {
                  subTaskId: s.id,
                  d
                };
              })
            );

            return context.answerSubTasks(answers).then((res) => {
              trackCompletions(res.completions, context.trackEvent);
              onSubmitDone(res);
            });
          }}
        >
          {({ submitting, values, pristine, error, errors }) => {
            const status = ss.every((s) => s.status === SubTaskStatus.DONE)
              ? SubTaskStatus.DONE
              : ss.every((s) => s.status === SubTaskStatus.SKIPPED)
              ? SubTaskStatus.SKIPPED
              : SubTaskStatus.OPEN;

            const disabled =
              (errors instanceof Object && Object.values(errors).length > 0) ||
              (errors instanceof Array && errors.length > 0) ||
              pristine ||
              status === SubTaskStatus.SKIPPED ||
              // TODO - strictly speaking, this might also need to
              // require a look into completion criteria.
              // Some fields might be optional!
              ss.some((s) => {
                const a = values[s.id];
                if (
                  s.status === 'SKIPPED' ||
                  s.requirementType !== RequirementType.MANDATORY
                ) {
                  return false;
                }
                if (!a) {
                  return true;
                }
                if (isArray(a)) {
                  return !a.length;
                }

                // Could also check for masked string here, but we don't have
                // easy access to the question. Might not be that important
                if (a.type === 'text') {
                  return !a.value;
                }
                if (a.type === 'select') {
                  return !a.value.id || !a.value.label;
                }
                if (a.type === 'address') {
                  return isAddressEmpty(a.value);
                }
                if (isScaleAnswer(a)) {
                  return typeof a.value !== 'number';
                }

                // if (a.type === QuestionType.SUPPORTING_ACTOR) {
                //   return isValidEmail(a.value);
                // }

                return false;
              });

            console.log(
              console.log(errors),
              'DISBALED',
              disabled,

              errors instanceof Object && Object.values(errors).length > 0,
              errors instanceof Array && errors.length > 0,
              pristine,

              ss.some((s) => {
                const a = values[s.id];
                if (
                  s.status === 'SKIPPED' ||
                  s.requirementType !== RequirementType.MANDATORY
                ) {
                  return false;
                }
                if (!a) {
                  return true;
                }
                if (isArray(a)) {
                  return !a.length;
                }

                // Could also check for masked string here, but we don't have
                // easy access to the question. Might not be that important
                if (a.type === 'text') {
                  return !a.value;
                }
                if (a.type === 'select') {
                  return !a.value.id || !a.value.label;
                }
                if (a.type === 'address') {
                  return isAddressEmpty(a.value);
                }
                if (isScaleAnswer(a)) {
                  return typeof a.value !== 'number';
                }

                // if (a.type === QuestionType.SUPPORTING_ACTOR) {
                //   return isValidEmail(a.value);
                // }

                return false;
              })
            );
            return (
              <FlexContainerVertical
                spacing={2}
                fullWidth
                alignItems={'flex-start'}
                justifyContent="flex-start"
              >
                {ss.map((s) => {
                  const qId = `q-${s.id}`;
                  const disabled = s.status === SubTaskStatus.SKIPPED;
                  const highlight = highlightedBlockId === s.id;
                  const { question } = s.data;
                  return (
                    <BlockContainer key={s.id}>
                      {question.type === 'text' && (
                        <SubTaskQuestionField
                          s={s}
                          qId={qId}
                          disabled={disabled}
                          highlight={highlight}
                          mode="multi"
                          dateFormat={dateFormat}
                        />
                      )}

                      {question.type === 'address' && (
                        <>
                          {question.label && (
                            <QuestionLabel>{question.label}</QuestionLabel>
                          )}

                          <FormField<{ value: Address; type: 'address' }>
                            name={s.id}
                          >
                            {({ input }) => (
                              <AddressForm
                                value={input.value.value || EMPTY_ADDRESS()}
                                onChange={(nextAddress) =>
                                  input.onChange({
                                    type: 'address',
                                    value: nextAddress
                                  })
                                }
                                excludedFields={question.excludedFields}
                                autoFocus={highlight}
                                disabled={disabled}
                              />
                            )}
                          </FormField>
                        </>
                      )}
                      {question.type === 'multiSelect' && (
                        <QuestionRadioContainer>
                          <FormControl component="fieldset">
                            <QuestionLabel>{question.label}</QuestionLabel>

                            <FormGroup>
                              {question.options.map((o) => {
                                return (
                                  <FormField
                                    name={s.id}
                                    type="checkbox"
                                    key={o.id}
                                    value={o.id}
                                  >
                                    {({ input }) => (
                                      <FormControlLabel
                                        key={o.id}
                                        value={o.id}
                                        control={
                                          <Checkbox
                                            color="primary"
                                            {...input}
                                          />
                                        }
                                        label={o.label}
                                      />
                                    )}
                                  </FormField>
                                );
                              })}
                            </FormGroup>
                          </FormControl>
                        </QuestionRadioContainer>
                      )}
                      {question.type === 'select' &&
                        (question.options.length < 5 ? (
                          <QuestionRadioContainer>
                            <FormControl component="fieldset">
                              <QuestionLabel htmlFor={qId}>
                                {question.label}
                              </QuestionLabel>

                              <FormField<{
                                type: 'select';
                                value: { id: string; label: string };
                              }>
                                name={s.id}
                              >
                                {({ input }) => (
                                  <RadioGroup
                                    name={qId}
                                    value={input.value?.value?.id || null}
                                    onChange={(ev) => {
                                      const opt = question.options.find(
                                        (o) => o.id === ev.target.value
                                      );
                                      if (opt) {
                                        input.onChange({
                                          type: 'select',
                                          value: opt
                                        });
                                      }
                                    }}
                                  >
                                    {question.options.map((o) => (
                                      <FormControlLabel
                                        key={o.id}
                                        value={o.id}
                                        control={<Radio color="primary" />}
                                        label={o.label}
                                      />
                                    ))}
                                  </RadioGroup>
                                )}
                              </FormField>
                            </FormControl>
                          </QuestionRadioContainer>
                        ) : (
                          <>
                            <QuestionLabel htmlFor={qId}>
                              {question.label}
                            </QuestionLabel>

                            <FormField<{
                              type: 'select';
                              value: {
                                id: string;
                                label: string;
                              };
                            }>
                              name={s.id}
                            >
                              {({ input }) => (
                                <Select
                                  fullWidth
                                  id={qId}
                                  variant="outlined"
                                  value={input.value?.value?.id || ''}
                                  onChange={(ev) => {
                                    const opt = question.options.find(
                                      (o) => o.id === ev.target.value
                                    );
                                    if (opt) {
                                      input.onChange({
                                        type: 'select',
                                        value: opt
                                      });
                                    }
                                  }}
                                  autoFocus={highlight}
                                  disabled={disabled}
                                >
                                  {question.options.map((o) => (
                                    <MenuItem key={o.id} value={o.id}>
                                      {o.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              )}
                            </FormField>
                          </>
                        ))}

                      {isScaleQuestion(question) && (
                        <QuestionRadioContainer>
                          <FormControl component="fieldset">
                            <QuestionLabel htmlFor={qId}>
                              {question.label}
                            </QuestionLabel>
                            <FormField<ScaleAnswerD | null> name={s.id}>
                              {({ input }) => (
                                question.type === QuestionType.RATING ? (
                                  <RatingInput
                                    question={question}
                                    value={
                                      input.value && isScaleAnswer(input.value)
                                        ? input.value.value
                                        : null
                                    }
                                    onChange={(next) =>
                                      input.onChange({
                                        type: QuestionType.RATING,
                                        value: next
                                      })
                                    }
                                    name={qId}
                                    id={qId}
                                    disabled={disabled}
                                  />
                                ) : (
                                  <LinearScaleInput
                                    question={question}
                                    value={
                                      input.value && isScaleAnswer(input.value)
                                        ? input.value.value
                                        : null
                                    }
                                    onChange={(next) =>
                                      input.onChange({
                                        type: QuestionType.LINEAR_SCALE,
                                        value: next
                                      })
                                    }
                                    name={qId}
                                    id={qId}
                                    disabled={disabled}
                                  />
                                )
                              )}
                            </FormField>
                          </FormControl>
                        </QuestionRadioContainer>
                      )}
                      {question.type === QuestionType.SUPPORTING_ACTOR && (
                        <>
                          <QuestionLabel htmlFor={qId}>
                            {question.label}
                          </QuestionLabel>

                          <FormField<{
                            value: string;
                            type: QuestionType.SUPPORTING_ACTOR;
                          }>
                            name={s.id}
                            validate={(input) => {
                              if (
                                s.requirementType !==
                                  RequirementType.MANDATORY &&
                                (!input || !input.value || input.value.trim() === '')
                              ) {
                                return undefined;
                              }
                              return input && isValidEmail(input.value)
                                ? undefined
                                : t(
                                    "Please enter this person's work email address"
                                  );
                            }}
                          >
                            {({ input, meta }) => (
                              <>
                                <TextField
                                  id={qId}
                                  fullWidth
                                  variant="outlined"
                                  multiline
                                  rows={1}
                                  maxRows={10}
                                  value={input.value.value}
                                  placeholder={t(
                                    'Enter their work email address'
                                  )}
                                  onChange={(ev) =>
                                    input.onChange({
                                      type: QuestionType.SUPPORTING_ACTOR,
                                      value: ev.target.value
                                    })
                                  }
                                  error={meta.dirty && meta.error}
                                  helperText={
                                    meta.dirty && meta.error ? meta.error : ''
                                  }
                                  autoFocus={highlight}
                                  disabled={disabled}
                                  InputProps={{
                                    readOnly: disabled
                                  }}
                                />
                              </>
                            )}
                          </FormField>
                        </>
                      )}
                    </BlockContainer>
                  );
                })}

                <QuestionButtonContainer>
                  <FormSubmitButton
                    variant={'contained'}
                    color={'primary'}
                    disabled={disabled}
                    submitting={submitting}
                    submitComponent={
                      <>
                        <ButtonLoader /> {t('Submit answers')}
                      </>
                    }
                  >
                    {t('Submit answers')}
                  </FormSubmitButton>
                  {status === SubTaskStatus.DONE && <CompletedLabel />}
                  {status === SubTaskStatus.SKIPPED && <SkippedLabel />}
                </QuestionButtonContainer>
              </FlexContainerVertical>
            );
          }}
        </Form>
      </>
    );
  }
);

const SubTaskVideoContainer = styled('div')((p) => ({
  position: 'relative'
}));

const SubTaskOverlay = styled('div')((p) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgb(0 0 0 / 65%)',
  pointerEvents: 'none',
  zIndex: 1
}));

const SubTaskOverlayLabel = styled('div')((p) => ({
  textAlign: 'center',
  color: p.theme.palette.background.paper,
  background: p.theme.palette.text.primary,
  padding: p.theme.spacing(2),
  borderRadius: p.theme.custom.border.radius(),
  fontSize: p.theme.custom.fontSize.s
}));

const SubTaskVideo = ({
  s,
  onComplete,
  status,
  mode
}: {
  s: ISubTaskWatchDenormalized;
  onComplete: () => void;
  status: SubTaskStatus;
  mode: 'LIVE' | 'PREVIEW';
}) => {
  const { t } = useTranslation();
  const [playing, setPlaying] = useState(false);
  return (
    <SubTaskVideoContainer>
      <VideoPlayerWithCompletionTracking
        url={s.data.url}
        onComplete={mode === 'LIVE' ? onComplete : () => undefined}
        onPlayPause={setPlaying}
      />
      {!playing && status !== SubTaskStatus.OPEN && (
        <SubTaskOverlay>
          <SubTaskOverlayLabel>
            {status === SubTaskStatus.DONE && <CompletedLabel />}
            {status === SubTaskStatus.SKIPPED && <SkippedLabel />}
            <div>{t('subTask.watch.watchAgainCta')}</div>
          </SubTaskOverlayLabel>
        </SubTaskOverlay>
      )}
    </SubTaskVideoContainer>
  );
};

const SubTaskDocumentRead = ({
  s,
  onComplete,
  status,
  highlight,
  mode
}: {
  s: ISubTaskDocumentReadDenormalized;
  onComplete: () => Promise<any>;
  status: SubTaskStatus;
  highlight: boolean;
  mode: 'LIVE' | 'PREVIEW';
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <DocumentTeaserWithPreview
      title={s.data.title}
      contentType={s.data.contentType}
      pages={s.data.pages}
      sizeInBytes={s.data.sizeInBytes}
      thumbnailUrl={s.data.thumbnailUrl}
      docUrl={s.data.docUrl}
      autoOpen={highlight}
      overlay={
        status === SubTaskStatus.OPEN ? undefined : (
          <SubTaskOverlayLabel>
            {status === SubTaskStatus.DONE && <CompletedLabel />}
            {status === SubTaskStatus.SKIPPED && <SkippedLabel />}
            <div>{t('Read again')}</div>
          </SubTaskOverlayLabel>
        )
      }
      pdfActions={({ state, close }) => {
        if (!state.ready) {
          return null;
        }
        if (s.completeOnDownload) {
          return (
            <ButtonWithPromise
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<Download size={16} />}
              pending={t('Completing...')}
              onClick={async () => {
                downloadFileFromUrl(`${s.data.title}.pdf`, s.data.docUrl);
                if (status === SubTaskStatus.OPEN && mode === 'LIVE') {
                  await onComplete(); // TODO need some loading state
                }
              }}
            >
              {t('Download file')}
            </ButtonWithPromise>
          );
        }
        return (
          <ButtonWithPromise
            variant="contained"
            color="primary"
            fullWidth
            disabled={state.currentPage !== state.totalPages}
            pending={t('Completing...')}
            onClick={async () => {
              if (status === SubTaskStatus.OPEN && mode === 'LIVE') {
                await onComplete(); // TODO need some loading state
              }
              close();
            }}
          >
            {t('Finished reading')}
          </ButtonWithPromise>
        );
      }}
    />
  );
};

export type Completions = {
  tasks?: { taskId: string; taskTemplateId: string }[];
  subTasks?: {
    taskId: string;
    taskTemplateId: string;
    subTaskId: string;
    subTaskTemplateId: string;
  }[];
};

export type SubTaskContext = {
  tz: string;
  user: IUserDenormalized;
  userId: string | null;

  answerSubTask: (
    subtaskId: string,
    value: SubTaskQuestionAnswer['d']
  ) => Promise<AnswerSubTasksResponse>;
  answerSubTasks: (
    answers: { subTaskId: string; d: SubTaskQuestionAnswer['d'] }[]
  ) => Promise<AnswerSubTasksResponse>;

  answerComplexSubtask: (
    subtaskId: string,
    value: SubTaskQuestionAnswer['d']
  ) => Promise<{ completions?: Completions; status: 'OK' } | any>;

  submitFileMonitorId: (subTaskId: string) => string;
  getSubTaskVisitUrl: (subtaskId: string, url: string) => string;
  trackSubTaskCompletion: (subTaskId: string, subTaskType: SubTaskType) => void;
  completeSubTask: (
    subTaskId: string
  ) => Promise<{
    completions?: Completions;
  }>;

  trackEvent: (event: ProductAnalyticsEvent) => void;

  constructNextFileSubmitMonitor: (
    file: File,
    subTaskId: string
  ) => ISubmitFileMonitor;
};

export const LayoutBlockComponent = ({
  taskId,
  b,
  context,
  highlight,
  blocks
}: {
  taskId: string;
  b: LayoutBlock;
  context?: SubTaskContext;
  highlight: boolean;
  blocks: TaskBlockDenormalized[];
}) => {
  switch (b.type) {
    case LayoutBlockType.COLUMNS:
      return (
        <ColumnsContainer
          columns={b.data.columns.length}
          columnWeights={b.data.columns.map((c) => c.columnWeight)}
        >
          {b.data.columns.map((c) => {
            const block = blocks.find((block) =>
              isSubTaskBlock(block)
                ? block.templateId === c.blockId
                : block.id === c.blockId
            );
            if (block && isContentBlock(block)) {
              return <Content d={block} />;
            }

            if (block && isSubTaskBlock(block) && context) {
              return (
                <SubTask
                  taskId={taskId}
                  s={block}
                  context={context}
                  highlight={highlight}
                  centerButtons
                />
              );
            }

            return null;
          })}
        </ColumnsContainer>
      );
  }
};

const SubTask = ({
  taskId,
  s,
  context,
  highlight,
  centerButtons,
  dateFormat = 'MM/DD/YYYY'
}: {
  taskId: string;
  s: SubTaskDenormalized;
  context: SubTaskContext;
  highlight: boolean;
  // Highly descriptive, as we're really only doing this for buttons atm
  centerButtons?: boolean;
  dateFormat?: string;
}) => {
  const { t } = useTranslation();
  const { mode } = useStandaloneAppContext();
  // const { trackEvent } = useProductAnalytics();

  // TODO error handling

  const { forceRerender } = useForceRerender();
  // done state updated right after the API call returns.
  // there's a little waiting period for the real time update to kick in - this bridges the gap
  const [forceDone, setForceDone] = useState(false);

  const trackCompletion = () => context.trackSubTaskCompletion(s.id, s.type);
  const complete = async () => {
    trackCompletion();
    await context.completeSubTask(s.id).then(({ completions }) => {
      trackCompletions(completions, context.trackEvent);
    });
    setForceDone(true);
    forceRerender();
  };

  const status = forceDone ? SubTaskStatus.DONE : s.status;
  switch (s.type) {
    case SubTaskType.CONFIRM:
      return (
        <SubTaskButtonContainer center={centerButtons}>
          <CompleteButton onClick={complete} status={status} mode={mode}>
            {s.data.label || `${t('Done')}!`}
          </CompleteButton>
        </SubTaskButtonContainer>
      );
    case SubTaskType.MEET:
      return (
        <SubTaskButtonContainer>
          <CompleteButton
            startIcon={<Check size={16} />}
            onClick={complete}
            status={status}
            mode={mode}
          >
            {t(
              s.data.role === 'MANAGER'
                ? 'subTask.meet.confirm.manager'
                : s.data.role === 'MENTOR'
                ? 'subTask.meet.confirm.mentor'
                : s.data.role === 'SKIP_LEVEL_MANAGER'
                ? 'subTask.meet.confirm.skipLevelManager'
                : s.data.role === 'HR'
                ? 'subTask.meet.confirm.hr'
                : s.data.role === 'TEAM'
                ? 'subTask.meet.confirm.team'
                : assertNever(s.data.role)
            )}
          </CompleteButton>
        </SubTaskButtonContainer>
      );
    case SubTaskType.CREATE_MEETING:
      return (
        <SubtaskCreateCalendarEvent
          context={context}
          subtask={s}
          onComplete={async () => {
            if (status !== SubTaskStatus.DONE) {
              trackCompletion();
              trackCompletionIntent(taskId, s.id, context.trackEvent);
            }
            setTimeout(() => {
              // THis is a problem- as this happens indirectly through
              // the redirect service, we don't really know at which point
              // in time we received an update...
              // As the user is moved off the page when clicking, this timeout
              // is a bit disguised though and might not be a problem.
              // Is 3 seconds enough though?
              forceRerender();
            }, 3000);
          }}
        />
      );
    case SubTaskType.SUBMIT:
      return (
        <SubTaskSubmit
          s={s}
          context={context}
          status={status}
          mode={mode}
          onSubmitStart={() => {
            if (status !== SubTaskStatus.DONE) {
              trackCompletion();
              trackCompletionIntent(taskId, s.id, context.trackEvent);
            }
          }}
        />
      );
    case SubTaskType.WATCH:
      return (
        <SubTaskVideo s={s} onComplete={complete} status={status} mode={mode} />
      );
    case SubTaskType.VISIT:
      const href = context.getSubTaskVisitUrl(s.id, s.data.url);

      // always allow to click links, just don't track it in preview
      return (
        <SubTaskButtonContainer>
          <CompleteLink
            href={mode === 'LIVE' ? href : s.data.url}
            status={status}
            startIcon={<LinkIcon size={16} strokeWidth={2.75} />}
            mode="LIVE"
            onClick={() => {
              if (status !== SubTaskStatus.DONE) {
                trackCompletionIntent(taskId, s.id, context.trackEvent);
                trackCompletion();
                // THis is a problem- as this happens indirectly through
                // the redirect service, we don't really know at which point
                // in time we received an update...
                // As the user is moved off the page when clicking, this timeout
                // is a bit disguised though and might not be a problem.
                // Is 3 seconds enough though?

                setTimeout(() => {
                  forceRerender();
                }, 3000);
              }
            }}
          >
            {s.data.label || truncateUrl(s.data.url, 52)}
          </CompleteLink>
          {status === SubTaskStatus.OPEN && (
            <ColoredChipLight size="small" color="yellow">
              {t('subTask.visit.notVisited')}
            </ColoredChipLight>
          )}
        </SubTaskButtonContainer>
      );
    case SubTaskType.QUESTION:
      return (
        <SubTaskQuestionSingle
          context={context}
          s={s}
          highlight={highlight}
          onSubmitDone={async () => {
            await trackCompletion();
            forceRerender();
          }}
          status={status}
          mode={mode}
          dateFormat={dateFormat}
        />
      );
    case SubTaskType.CALENDLY_INVITE:
      const toSchedulingUrl = () => {
        if (!s.data.event) {
          return '';
        }
        const u = new URL(s.data.event.schedulingUrl);
        u.searchParams.set('name', toFullName(context.user));
        u.searchParams.set('email', context.user.email);
        return u.toString();
      };
      // link can be visited in preview mode as well
      return (
        <SubTaskButtonContainer>
          <CompleteLink
            href={toSchedulingUrl()}
            startIcon={<Calendar size={16} strokeWidth={2.75} />}
            status={status}
            mode="LIVE"
            onClick={() => {
              if (status !== SubTaskStatus.DONE) {
                trackCompletionIntent(taskId, s.id, context.trackEvent);
                trackCompletion();
              }
            }}
          >
            {t('subTask.calendlyInvite.verb', {
              eventName: s.data.event?.name || ''
            })}
          </CompleteLink>
        </SubTaskButtonContainer>
      );
    case SubTaskType.DOCUMENT_READ:
      return (
        <SubTaskDocumentRead
          s={s}
          onComplete={complete}
          status={status}
          mode={mode}
          highlight={highlight}
        />
      );
    case SubTaskType.SWAG_UP_CHOICE:
      return (
        <SubTaskSwagUpChoice
          s={s}
          context={context}
          onSubmitDone={() => {
            trackCompletion();
            forceRerender();
          }}
          status={status}
          mode={mode}
          highlight={highlight}
        />
      );
    case SubTaskType.DATA_FIELD_CHANGE:
      return <SubTaskDateFieldChange s={s} status={status} />;
    case SubTaskType.DOCUSIGN_ENVELOPE_SIGN:
      return <SubTaskDocuSignEnvelopeSign s={s} status={status} />;
    case SubTaskType.BACKGROUND_CHECK_INVITE:
      return (
        <SubTaskBackgroundCheckInvite s={s} status={status} mode="LIVE" />
      );
    case SubTaskType.COMPLETE_LMS_MODULE:
      return <SubTaskCompleteLmsModule s={s} status={status} />;
    default:
      return assertNever(s);
  }
};

const TaskCompletionCriteria = ({
  criteria
}: {
  criteria: ITaskDenormalized['customCompletionCriteria'];
}) => {
  const { t } = useTranslation();
  if (!criteria.length) {
    return null;
  }
  if (criteria.length > 1) {
    console.log(
      'Several completion criteria found, but only supporting one at the moment',
      criteria
    );
  }
  const criterium = criteria[0];
  if (criterium.type !== 'SUBSET') {
    console.log('Criterium not supported yet', criterium);
    return null;
  }

  return (
    <>
      {' • '}
      {t('taskCompletionCriteria.userFacing.hint2', {
        count: criterium.minimumRequired
      })}
    </>
  );
};

const TaskBodyContainer = styled('div')<{ margin?: number }>((p) => ({
  marginTop: p.theme.spacing(p.margin ?? 2),
  wordBreak: 'break-word'
}));

const BlockContainer = styled('div')((p) => ({ width: '100%' }));

const BlockListContainer = styled('div')<{ margin?: number }>((p) => ({
  marginTop: p.theme.spacing(p.margin ?? 2),
  marginBottom: p.theme.spacing(p.margin ?? 4),
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: p.theme.spacing(2)
}));

type CalloutColor = IContentCalloutTemplate['data']['color'];
export const CalloutContainer = styled('div')<{ color: CalloutColor }>((p) => ({
  width: '100%',
  boxSizing: 'border-box',
  padding: p.theme.spacing(),
  background: p.theme.custom.colors[p.color].w200,
  borderLeft: `3px solid ${p.theme.custom.colors[p.color].w500}`
}));

export const ColumnsContainer = styled('div')<{
  columns: number;
  columnWeights: number[];
  vAlign?: 'start' | 'center' | 'end';
}>((p) => ({
  display: 'grid',
  // Fill the parent so the weighted columns get their full width even when this
  // grid is a flex-start child — the v2 hub MessageBody renders layout blocks as
  // direct children of a FlexContainerVertical (alignItems: flex-start), which
  // would otherwise shrink-wrap this grid so the columns collapse and bunch to the
  // left. Mirrors MarkdownContainer/ImageContainer/Divider (all width:100%); no-op
  // in the width:100% BlockContainer task path and the stretched builder preview.
  width: '100%',
  gridTemplateColumns: `${p.columnWeights
    .map((w) => `minmax(0, ${w}fr)`)
    .join(' ')}`,
  gridColumnGap: p.theme.spacing(2),
  alignItems:
    p.vAlign === 'center'
      ? 'center'
      : p.vAlign === 'end'
      ? 'flex-end'
      : 'flex-start'
}));

const EmptyBlock = styled('div')<{ height?: number }>((p) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: p.height || 50,
  color: p.theme.custom.colors.gray.w400
}));

export const Content = ({ d }: { d: ContentTemplate }) => {
  const { t } = useUnsafeTranslation();
  const theme = useTheme();
  switch (d.type) {
    case ContentType.HEADING:
      const sizeVariant = d.data.size === 'L' ? 'h3' : 'h5';
      return (
        // width:100% so this heading fills the flex-start message-body column
        // instead of shrink-wrapping to its text — without it the inner
        // MarkdownContainer's `textAlign` (center/right) has no room to take
        // effect and the heading always reads left. Mirrors the width:100% on
        // MarkdownContainer/ColumnsContainer/BlockContainer (the text/body blocks
        // that already align correctly).
        <Typography
          variant={sizeVariant}
          component={sizeVariant}
          style={{ width: '100%' }}
        >
          <MarkdownText
            t={{ t: d.data.t, v: 1, textAlign: d.data.textAlign }}
          />
        </Typography>
      );
    case ContentType.TEXT:
      return <MarkdownText t={d.data.t} />;
    case ContentType.CALLOUT:
      return (
        <CalloutContainer color={d.data.color}>
          <MarkdownText t={d.data.t} />
        </CalloutContainer>
      );

    case ContentType.IMAGE:
      // TODO default dimensions
      return (
        <ImageContainer align={d.data.align} width={d.data.width}>
          <Zoom zoomMargin={theme.spacing(4)}>
            <Img
              width="100%"
              alt={d.data.alt}
              title={d.data.alt}
              src={d.data.src}
              key={d.data.src}
              crossorigin="anonymous"
              unloader={
                <EmptyBlock style={{ width: '100%' }} height={100}>
                  <AlertCircle size={20} />
                  <div>{t('Image not found')}</div>
                </EmptyBlock>
              }
              loader={
                <EmptyBlock style={{ width: '100%' }} height={100}>
                  <CircularProgress color="inherit" />
                </EmptyBlock>
              }
            />
          </Zoom>
        </ImageContainer>
      );
    case ContentType.DIVIDER:
      return (
        <Divider light={d.data.variant === 'light'} style={{ width: '100%' }} />
      );
    default:
      return assertNever(d);
  }
};

export const TaskBody = ({
  taskId,
  context,
  subtasks,
  highlightedSubTaskId,
  noContainerMargins
}: {
  taskId: string;
  highlightedSubTaskId?: string;
  subtasks: ITaskDenormalized['blocks'];
  context: {
    user: IUserDenormalized;
    userId: string | null;
    org: IOrganizationDenormalized;
    subTaskContext: SubTaskContext;
  };
  noContainerMargins?: boolean;
}) => {
  const groupedBlocks = useMemo(() => {
    const res: (
      | {
          type: 'single';
          b: TaskBlockDenormalized;
        }
      | {
          // Might support other groups later
          type: 'group';
          blockType: 'QUESTION';
          bs: ISubTaskQuestionDenormalized[];
        }
    )[] = [];
    let currentGroup: {
      type: 'group';
      blockType: 'QUESTION';
      bs: ISubTaskQuestionDenormalized[];
    } = {
      type: 'group',
      blockType: 'QUESTION',
      bs: []
    };
    subtasks.forEach((b, i) => {
      const processCurrentGroup = () => {
        if (currentGroup.bs.length === 1) {
          const previousBlock = currentGroup.bs[0];
          currentGroup.bs = [];
          res.push({ type: 'single', b: previousBlock });
        }
        if (currentGroup.bs.length > 1) {
          res.push(currentGroup);
          currentGroup = { type: 'group', blockType: 'QUESTION', bs: [] };
        }
      };
      if (b.type === 'QUESTION') {
        currentGroup.bs.push(b);
      } else {
        processCurrentGroup();
        res.push({ type: 'single', b });
      }
      if (i === subtasks.length - 1) {
        processCurrentGroup();
      }
    });
    return res;
  }, [subtasks]);

  return (
    <TaskBodyContainer margin={noContainerMargins ? 0 : undefined}>
      <BlockListContainer margin={noContainerMargins ? 0 : undefined}>
        {compact(
          groupedBlocks.map((g, i) => {
            if (g.type === 'single') {
              if (isSubTaskBlock(g.b)) {
                if (g.b.parentLayoutElement) {
                  return null;
                } else {
                  return (
                    <BlockContainer key={g.b.id}>
                      <SubTask
                        taskId={taskId}
                        s={g.b}
                        context={context.subTaskContext}
                        highlight={highlightedSubTaskId === g.b.id}
                        dateFormat={context.org.dateFormats?.MMDDYYYY || 'MM/DD/YYYY'}
                      />
                    </BlockContainer>
                  );
                }
              }
              if (isContentBlock(g.b)) {
                if (g.b.parentLayoutElement) {
                  return null;
                }
                return (
                  <BlockContainer key={g.b.id}>
                    <Content d={g.b} />
                  </BlockContainer>
                );
              }
              if (isLayoutTemplateBlock(g.b)) {
                return (
                  <BlockContainer key={g.b.id}>
                    <LayoutBlockComponent
                      taskId={taskId}
                      b={g.b}
                      blocks={flatten(
                        groupedBlocks.map((gb) =>
                          gb.type === 'single' ? gb.b : gb.bs
                        )
                      )}
                      context={context.subTaskContext}
                      highlight={highlightedSubTaskId === g.b.id}
                    />
                  </BlockContainer>
                );
              }
              return null;
            }
            if (g.type === 'group') {
              if (g.blockType === 'QUESTION') {
                return (
                  <BlockContainer key={g.bs.map((b) => b.id).join()}>
                    <SubTaskQuestionMulti
                      context={context.subTaskContext}
                      highlightedBlockId={highlightedSubTaskId}
                      ss={g.bs}
                      dateFormat={context.org.dateFormats?.MMDDYYYY || 'MM/DD/YYYY'}
                    />
                  </BlockContainer>
                );
              }
              return assertNever(g.blockType);
            }

            return assertNever(g);
          })
        )}
      </BlockListContainer>
    </TaskBodyContainer>
  );
};

const DateWithTooltip = ({
  date,
  textBefore,
  textAfter
}: {
  date: Timestamp;
  textBefore?: string;
  textAfter?: string;
}) => {
  if (!date) {
    return null;
  }
  const dateSimple = formatDate(toMoment(date), 'MMMM Do');
  const dateComplete = formatDate(toMoment(date), 'dddd, MMMM Do YYYY, h:mm a');
  return (
    <Tooltip title={dateComplete}>
      <span>
        {textBefore && textBefore + ' '}
        {dateSimple}
        {textAfter && ' ' + textAfter}
      </span>
    </Tooltip>
  );
};

const AdditionalInfoForTask = ({
  additionalInfo = EMPTY_ARR,
  endDate,
  status,
  customHints
}: {
  additionalInfo: AdditionalInfo[] | undefined | null;
  endDate: Timestamp | null;
  status: TaskStatus;
  customHints: IExperienceDenormalized['customHints'];
}) => {
  const { t } = useUnsafeTranslation();
  const infos = useMemo(() => {
    const n = now();
    return (
      additionalInfo?.filter((x) => {
        if (
          x.type === AdditionalInfoType.CAUSE_ITEM_LATE &&
          status === TaskStatus.LATE
        ) {
          return true;
        }
        if (
          x.type === AdditionalInfoType.EFFECT_ITEM_LATE_WARNING &&
          status === TaskStatus.LATE
        ) {
          return true;
        }

        if (
          x.type === AdditionalInfoType.EFFECT_ITEM_LATE_INFO &&
          status === TaskStatus.RUNNING &&
          endDate
        ) {
          return tsIsAfter(n, addToTs(endDate, -ONE_DAY));
        }

        return false;
      }) || []
    );
  }, [additionalInfo, endDate, status]);

  const activeInfos = infos.filter(
    (info) => !isAdditionalInfoDisabled(info, customHints)
  );

  if (!activeInfos.length) {
    return null;
  }
  return (
    <FlexContainerVertical marginTop={1}>
      {activeInfos.map((x, i) => (
        <React.Fragment key={i}>
          {x.type === AdditionalInfoType.EFFECT_ITEM_LATE_WARNING && (
            <InfoBox color="red" fullWidth>
              {customHints?.[AdditionalInfoType.EFFECT_ITEM_LATE_WARNING] ||
                t(
                  `Your colleagues’ work is blocked until you have completed this task. Please complete it ASAP.`
                )}
            </InfoBox>
          )}
          {x.type === AdditionalInfoType.EFFECT_ITEM_LATE_INFO && (
            <InfoBox color="yellow" fullWidth>
              {customHints?.[AdditionalInfoType.EFFECT_ITEM_LATE_INFO] ||
                t(
                  `Your colleagues’ work is blocked until you have completed this task. Please ensure it’s completed before the deadline.`
                )}
            </InfoBox>
          )}
          {x.type === AdditionalInfoType.CAUSE_ITEM_LATE && (
            <InfoBox color="yellow" fullWidth>
              {customHints?.[AdditionalInfoType.CAUSE_ITEM_LATE] ||
                t(
                  `You’re receiving this late because your colleague completed a preceding task late. Please complete your task ASAP as the deadline has already passed.`
                )}
            </InfoBox>
          )}
        </React.Fragment>
      ))}
    </FlexContainerVertical>
  );
};

export type TaskContext = {
  // Maybe make own type for status
  status: TaskStatus;
  startDate: Timestamp;
  endDate: Timestamp | null;
  completedAt: Timestamp | null;
  title: string;
  completionCriteria: TaskTemplateCompletionCritertiaSubSet[];

  subtasks: TaskBlockDenormalized[];

  user: IUserDenormalized;
  userId: string | null;
  org: IOrganizationDenormalized;

  headerLink?: string;
  headerOnClickHandler?: () => void;
  subTaskContext: SubTaskContext;

  additionalInfo: AdditionalInfo[] | null;
  customHints: IExperienceDenormalized['customHints'];
};

export const Task = ({
  taskId,
  context,
  variant,
  highlightedSubTaskId
}: {
  taskId: string;
  context: TaskContext;
  variant: TaskVariant;
  highlightedSubTaskId?: string;
}) => {
  const { t } = useTranslation();

  const header = (
    <>
      <TaskHeader dense={variant !== 'expanded'}>
        {variant !== 'teaser' && (
          <TaskStatusChip status={context.status} color="light" autoWidth />
        )}

        <div>
          <Typography variant="h5" component="h5">
            {context.title}
          </Typography>
        </div>
      </TaskHeader>
      <FlexContainer direction="column" alignItems="flex-start" spacing={0.5}>
        <Typography variant="caption" component="div">
          {context.status === TaskStatus.NOT_STARTED && (
            <DateWithTooltip
              textBefore={capitalize(t('starts'))}
              date={context.startDate}
            />
          )}
          {(context.status === TaskStatus.RUNNING ||
            context.status === TaskStatus.LATE) &&
            context.endDate && (
              <DateWithTooltip
                textBefore={capitalize(t('due'))}
                textAfter=" "
                date={context.endDate}
              />
            )}{' '}
          {context.status === TaskStatus.COMPLETE && context.completedAt && (
            <DateWithTooltip
              textBefore={capitalize(t('completed'))}
              date={context.completedAt || context.endDate}
            />
          )}
          {variant === 'expanded' && (
            <TaskCompletionCriteria criteria={context.completionCriteria} />
          )}
        </Typography>
      </FlexContainer>
    </>
  );
  return (
    <TaskContainer variant={variant}>
      {context.headerLink ? (
        <Link to={context.headerLink}>{header}</Link>
      ) : context.headerOnClickHandler ? (
        <div
          role="button"
          style={{ cursor: 'pointer ' }}
          onClick={context.headerOnClickHandler}
        >
          {header}
        </div>
      ) : (
        header
      )}
      {variant === 'expanded' && (
        <>
          <AdditionalInfoForTask
            additionalInfo={context.additionalInfo}
            endDate={context.endDate}
            status={context.status}
            customHints={context.customHints}
          />
          <TaskBody
            taskId={taskId}
            context={{
              org: context.org,
              user: context.user,
              userId: context.userId,
              subTaskContext: context.subTaskContext
            }}
            subtasks={context.subtasks}
            highlightedSubTaskId={highlightedSubTaskId}
          />
        </>
      )}
    </TaskContainer>
  );
};
